module.exports = __webpack_public_path__ + "ed6fa06a180b0f3e155b3acc3758c450.svg";